import { environment } from "@hub-workspace/apps/logged-home/src/environments/environment";

type NextAccountTypeBenefits = {
  title: string,
  items: string[];
}

export type AccountTypeContent = {
  currentAccountType: 'REGISTRATION' | 'DIGITAL' | 'EXCLUSIVE',
  currentAccountLabel: string,
  nextAccountType?: 'DIGITAL' | 'EXCLUSIVE',
  nextAccountLabel?: string,
  nextAccountTypeMinValue: number,
  cardTitle: string,
  cardText: string,
  nextAccountTypeBenefits: NextAccountTypeBenefits[],
}

const accountTypesContent: AccountTypeContent[] = [
  {
    currentAccountType: 'REGISTRATION',
    currentAccountLabel: 'Cadastro Finalizado',
    nextAccountType: 'DIGITAL',
    nextAccountLabel: 'Conta Digital',
    nextAccountTypeMinValue: 0.01,
    cardTitle: 'Comece a investir e ative sua Conta Digital.',
    cardText: `Você já finalizou seu cadastro e abriu sua conta. <b>Ao trazer qualquer valor para a ${ environment.isNewBrand ? "Santander Corretora" : "Toro" },</b> você ativa sua Conta Digital.`,
    nextAccountTypeBenefits: [
      {
        title: 'Tire suas dúvidas',
        items: [
          `WhatsApp da ${ environment.isNewBrand ? "Assessoria" : "Toro" }`,
          'Live da Assessoria',
          'Ajuda dentro do site',
          'Tutoriais e Cursos Grátis',
          'Live Palavra do Analista (Day Trade e Mercado)',
          'Página com dúvidas frequentes',
          'Análises de mercado'
        ]
      }
    ]
  },
  {
    currentAccountType: 'DIGITAL',
    currentAccountLabel: 'Conta Digital',
    nextAccountType: 'EXCLUSIVE',
    nextAccountLabel: 'Conta Exclusiva',
    nextAccountTypeMinValue: 250000,
    cardTitle: 'Seja um investidor Exclusivo.',
    cardText: 'Atualmente, você tem todos os benefícios da Conta Digital. Assim que os seus investimentos chegarem a R$250.000, você passa a contar também com o suporte de um <b>Assessor Exclusivo.</b>',
    nextAccountTypeBenefits: [
      {
        title: 'Assessor Exclusivo',
        items: [
          'Acompanhamento exclusivo da carteira',
          'Reuniões periódicas com Assessor',
          'Análise de portfólio de recomendações',
          'Execução de investimentos diretamente com o Assessor',
          'Conteúdos exclusivos da área de Análise',
          'Investimentos exclusivos',
        ]
      }
    ]
  },
  {
    currentAccountType: 'EXCLUSIVE',
    currentAccountLabel: 'Conta Exclusiva',
    nextAccountTypeMinValue: Infinity,
    cardTitle: 'Aproveite sua Conta Exclusiva.',
    cardText: 'Como você investiu mais de R$ 250.000, você tem todos os benefícios da Conta Exclusiva. Fale com seu Assessor Exclusivo diretamente pelo WhatsApp.',
    nextAccountTypeBenefits: [
      {
        title: 'Veja os principais benefícios:',
        items: [
          'Assessor Exclusivo',
          'Acompanhamento exclusivo da carteira',
          'Reuniões periódicas com Assessor',
          'Análise de portfólio de recomendações',
          'Execução de investimentos diretamente com o Assessor',
          'Conteúdos exclusivos da área de Análise',
          'Investimentos exclusivos',
        ]
      }
    ]
  }
]

export const getAccountTypeContentByTotalNetEquity = (totalNetEquity: number, hasAdvisor: boolean): AccountTypeContent => {
  if (hasAdvisor) return accountTypesContent.find(accountType => accountType.currentAccountType === 'EXCLUSIVE');
  const baseValue = totalNetEquity == null ? 0 : totalNetEquity;
  return accountTypesContent.find((accountType) => baseValue < accountType.nextAccountTypeMinValue)
}
